<div class="kz-checkboxes-grid">
  <kz-field absErrorMsg="true" *ngFor="let projectUtility of kazaForm.get('utilities')['controls']; let i = index">
    <input kzCheckBox type="checkbox" id="kz-checkbox-typeofgood{{i}}"
    #projectUtilityCheckbox
    [formControl]="projectUtility"
    />
    <label kzLabel for="kz-checkbox-typeofgood{{i}}">{{projectUtilities[i].name}}</label>
  </kz-field>
</div>
